import types from './types'

const updateUnreadMessageCount = (payload) => ({
  type: types.UPDATE_OUTREACH_MESSAGE_COUNT,
  payload,
})

export default {
  updateUnreadMessageCount,
}
